import { render } from "./ReadingTestView.vue?vue&type=template&id=950ab7c2&scoped=true&lang=true"
import script from "./ReadingTestView.vue?vue&type=script&lang=js"
export * from "./ReadingTestView.vue?vue&type=script&lang=js"

import "./ReadingTestView.vue?vue&type=style&index=0&id=950ab7c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950ab7c2"]])

export default __exports__